module.exports = __webpack_public_path__ + "img/cns_email_ios19.94f3c898.png";